import axios from "axios";

const BASE_URL = process.env.REACT_APP_STATS_API_BASE_URL;

export default class StatsApi {
  getSports() {
    return axios.get(`${BASE_URL}/sports`).then(r => r.data);
  }

  getSchedule(date = "", sportId = 1) {
    return axios
      .get(`${BASE_URL}/schedule?sportId=${sportId}&date=${date}&hydrate=team`)
      .then(r => r.data);
  }

  getEventSchedule(date = "", sportId = 1) {
    return axios
      .get(`${BASE_URL}/schedule/events?sportId=${sportId}&date=${date}`)
      .then(r => r.data);
  }

  getGame(gamePk) {
    return axios
      .get(
        `${BASE_URL}/schedule?gamePk=${gamePk}&hydrate=team&useLatestGames=true`
      )
      .then(r => r.data);
  }

  getEvent(gamePk) {
    return axios
      .get(`${BASE_URL}/schedule/events?gamePk=${gamePk}`)
      .then(r => r.data);
  }

  getAtBats(gamePk) {
    return axios
      .get(`${BASE_URL}/game/${gamePk}/playByPlay?language=EN`)
      .then(r => r.data);
  }
}



// WEBPACK FOOTER //
// ./src/httpClients/StatsApi.js